const NEWS_DATA_URL = './news-data.json';

export const getAllNews = async () => {
  try {
    const response = await fetch(NEWS_DATA_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Failed to load JSON file: ${response.status}`);
    }
    
    const data = await response.json();
    
    const sortedNews = [...data.news].sort((a, b) => 
      new Date(b.date).getTime() - new Date(a.date).getTime()
    );
    
    return {
      success: true,
      news: sortedNews,
      lastUpdated: data.lastUpdated || new Date().toISOString()
    };
  } catch (error) {
    console.error('Error fetching news data:', error);
    return { success: false, news: [], message: error.message };
  }
};

export const getImportantNews = async () => {
  try {
    const result = await getAllNews();
    
    if (result.success) {
      const importantNews = result.news.filter(item => item.important === true);
      
      return {
        success: true,
        news: importantNews,
        lastUpdated: result.lastUpdated
      };
    } else {
      throw new Error('Failed to get news data');
    }
  } catch (error) {
    console.error('Error fetching important news:', error);
    throw error;
  }
};

export const getNewsById = async (id) => {
  try {
    if (!id || isNaN(parseInt(id))) {
      throw new Error('Invalid news ID');
    }
    
    const result = await getAllNews();
    
    if (!result.success) {
      throw new Error('Failed to get news data');
    }
    
    const newsItem = result.news.find(item => item.id === parseInt(id));
    
    if (!newsItem) {
      throw new Error(`News item with ID ${id} not found`);
    }
    
    return {
      success: true,
      newsItem: newsItem
    };
  } catch (error) {
    console.error(`Error fetching news item with ID ${id}:`, error);
    throw error;
  }
};